module.exports = __webpack_public_path__ + "media/images/front/pc/institution-treatment-information/logo_mrso-5875d5f577f9809090de0b34f236216f.svg";